/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 */
import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { FiscalBrandFillSegmented } from './FiscalBrandFillSegmented';
import type { ArcaEnvironment } from '../domain/fiscalTypes';
import { spacing } from '../../shared/theme/spacing'
import { typography } from '../../shared/theme/typography';
import { ticketColors } from '../../shared/theme/ticketColors';

const ENV_OPTIONS = [
  { value: 'homologacion' as const, label: 'Homologación', shortLabel: 'Homologación' },
  { value: 'produccion' as const, label: 'Producción', shortLabel: 'Producción' },
];

export type ArcaEnvironmentSelectorProps = {
  value: ArcaEnvironment;
  onChange: (env: ArcaEnvironment) => void;
  disabled?: boolean;
};

export function ArcaEnvironmentSelector({ value, onChange, disabled = false }: ArcaEnvironmentSelectorProps) {
  return (
    <View style={styles.wrap}>
      <Text style={styles.fieldLabel}>Ambiente ARCA</Text>
      <FiscalBrandFillSegmented
        options={ENV_OPTIONS}
        value={value}
        onChange={onChange}
        disabled={disabled}
        accessibilityLabel="Ambiente ARCA"
      />
      <View style={styles.detailPanel}>
        {value === 'homologacion' ? (
          <>
            <Text style={styles.detailTitle}>Homologación</Text>
            <Text style={styles.detailBody}>Es de prueba. Los CAE no valen para un cliente de verdad.</Text>
          </>
        ) : (
          <>
            <Text style={styles.detailTitle}>Producción</Text>
            <Text style={styles.detailBody}>
              Los comprobantes valen de verdad. Hace falta el certificado de producción.
            </Text>
          </>
        )}
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  wrap: { gap: spacing.sm },
  fieldLabel: {
    ...typography.caption,
    color: ticketColors.ink2,
    textTransform: 'uppercase',
    letterSpacing: 0.8,
    fontWeight: '700',
  },
  detailPanel: {
    borderRadius: 16,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    backgroundColor: ticketColors.paper2,
    padding: spacing.md,
    gap: spacing.xs,
  },
  detailTitle: { ...typography.body, color: ticketColors.ink, fontWeight: '700' },
  detailBody: { ...typography.caption, color: ticketColors.ink2, lineHeight: 18 },
});
